import { DestinationSearchBlockOffer } from '@fcom/cms/interfaces';

export interface FetchOffersResponseData {
  destinationPrices: { [destination: string]: OfferDestination };
}

export interface OfferDestination {
  origin: string;
  currency: string;
  prices: OfferPrice[];
  locationData?: LocationData;
}

export interface LocationData {
  continentCode: string;
  country: string;
  countryCode: string;
  cityName: string;
  picture: string;
}

export interface OfferPrice {
  departure: string;
  return: string;
  price: string;
}

export enum Continent {
  EUROPE = 'Europe',
  MIDDLE_EAST = 'Middle East',
  AMERICA = 'Americas',
  ASIA_PACIFIC = 'Asia-Pacific',
  AFRICA = 'Africa',
}

export interface CategorizedDestination {
  [key: string]: DestinationSearchBlockOffer[];
}
